import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { registerServiceWorker } from '@/lib/pwa'
import './design/tokens.css'
import './design/base.css'

const container = document.getElementById('root')
if (!container) throw new Error('Namu could not find its mount point.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// After the app is up, never before: a service worker registered during the
// first render competes with the page it is meant to serve.
registerServiceWorker()
